export default Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        cover: null,
    },
    initialize({ id }) {
        this.set('cover', `${window.appConfig.imagesDomain}/photos/operator/${id}.png`);
    },
});